import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container, Form} from 'react-bootstrap';
import './AppversionModal.css';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class AppversionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        andrCurntV: this.props.editData ? this.props.editData.andrCurntV : null,
        andrMinV: this.props.editData ? this.props.editData.andrMinV : null,
        iosCurntV: this.props.editData ? this.props.editData.iosCurntV : null,
        iosMinV: this.props.editData ? this.props.editData.iosMinV : null,
        apiDown: this.props.editData ? this.props.editData.apiDown : null,
        chemistDist: this.props.editData
          ? this.props.editData.chemistDist
          : null,
        distributorDist: this.props.editData
          ? this.props.editData.distributorDist
          : null,
      },
    };
    this.onChangeAndrd = this.onChangeAndrd.bind(this);
  }

  onChangeAndrd = value => {
    let field = value.target.name;
    let data = value.target.value;

    if (field === 'currentVersion' && this.props.os === 'android') {
      this.setState({
        value: {...this.state.value, andrCurntV: data},
      });
    } else if (field === 'currentVersion' && this.props.os === 'ios') {
      this.setState({
        value: {...this.state.value, iosCurntV: data},
      });
    } else if (field == 'minimumVersion' && this.props.os === 'android') {
      this.setState({
        value: {...this.state.value, andrMinV: data},
      });
    } else if (field == 'minimumVersion' && this.props.os === 'ios') {
      this.setState({
        value: {...this.state.value, iosMinV: data},
      });
    } else if (field === 'chemistDist') {
      this.setState({
        value: {...this.state.value, chemistDist: data},
      });
    } else if (field === 'distributorDist') {
      this.setState({
        value: {...this.state.value, distributorDist: data},
      });
    }
    console.log('+++++++++++++++++++++++++++', data);
  };

  selectApidown = e => {
    this.setState({value: {...this.state.value, apiDown: e.target.value}});
  };

  submit = () => {
    const VersionData = {
      andrCurntV: this.state.value.andrCurntV,
      andrMinV: this.state.value.andrMinV,
      iosCurntV: this.state.value.iosCurntV,
      iosMinV: this.state.value.iosMinV,
      apiDown: this.state.value.apiDown,
      chemistDist: this.state.value.chemistDist,
      distributorDist: this.state.value.distributorDist,
    };

    if (
      VersionData.andrCurntV !== '' &&
      VersionData.andrMinV !== '' &&
      VersionData.iosCurntV !== '' &&
      VersionData.iosMinV !== '' &&
      VersionData.chemistDist !== '' &&
      VersionData.distributorDist !== ''
    ) {
      this.props.editAppversion(VersionData);
      this.props.handleClose();
    } else {
      toast.error('All fields are mandatory', {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        andrCurntV: nextProps.editData.andrCurntV,
        andrMinV: nextProps.editData.andrMinV,
        iosCurntV: nextProps.editData.iosCurntV,
        iosMinV: nextProps.editData.iosMinV,
        apiDown: nextProps.editData.apiDown,
        chemistDist: nextProps.editData.chemistDist,
        distributorDist: nextProps.editData.distributorDist,
      },
    });
  }

  render() {
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>
                  {this.props.os === 'android'
                    ? 'App Version(Android)'
                    : 'App Version(IOS)'}
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Form>
                  <Row>
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="currentVersion">
                        <Form.Label>Current Version</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="currentVersion"
                          onChange={this.onChangeAndrd}
                          value={
                            this.props.os === 'android'
                              ? this.state.value.andrCurntV
                              : this.state.value.iosCurntV
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="minimumVersion">
                        <Form.Label>Minimum Version</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="minimumVersion"
                          value={
                            this.props.os === 'android'
                              ? this.state.value.andrMinV
                              : this.state.value.iosMinV
                          }
                          onChange={this.onChangeAndrd}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="chemistDist">
                        <Form.Label>Chemist Distance</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="chemistDist"
                          // value={
                          //   this.props.os === 'android'
                          //     ? this.state.value.chemistDist
                          //     : this.state.value.chemistDist
                          // }
                          value={this.state.value.chemistDist}
                          onChange={this.onChangeAndrd}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group controlId="distributorDist">
                        <Form.Label>Distributor Distance</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="distributorDist"
                          // value={
                          //   this.props.os === 'android'
                          //     ? this.state.value.distributorDist
                          //     : this.state.value.distributorDist
                          // }
                          value={this.state.value.distributorDist}
                          onChange={this.onChangeAndrd}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Label>API Down</Form.Label>
                      {this.props.editData.apiDown
                        ? <Form.Control
                            as="select"
                            onChange={this.selectApidown}
                          >
                            <option>true</option>
                            <option>false</option>
                          </Form.Control>
                        : <Form.Control
                            as="select"
                            onChange={this.selectApidown}
                          >
                            <option>false</option>
                            <option>true</option>
                          </Form.Control>}
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Modal.Body>

            <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
              <Button onClick={this.submit}>Submit</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default AppversionModal;
